import script from "./H5Ads.vue?vue&type=script&lang=ts&setup=true"
export * from "./H5Ads.vue?vue&type=script&lang=ts&setup=true"

import "./H5Ads.vue?vue&type=style&index=0&id=8f7413bc&lang=css"

const __exports__ = script;

export default __exports__